import http from './httpService';

const apiEndPoint = '/teams';

export function getTeam(teamId) {
  return http.get(url(teamId));
}

export function createTeam(teamName) {
  return http.post(apiEndPoint, { name: teamName });
}

export function allowJoining(value) {
  const body = {
    allow: value,
  };
  return http.patch(`${apiEndPoint}/allowJoining`, body);
}

export function removeUserFromTeam(teamId, userId) {
  return http.delete(`${apiEndPoint}/${teamId}/users/${userId}`);
}

function url(id) {
  return `${apiEndPoint}/${id}`;
}
